// GENERAL
export enum ChooseStationStepFormFieldsEnum {
  HomeAddress = "homeAddress",
  SourceStation2Id = "sourceStation2Id",
  AcceptTerms = "acceptTerms",
}

// CLAL
export enum ClalChooseStationStepFormFieldsEnum {
  WorkerType = "workerType",
  Phone = "phone",
  WorkerId = "workerId",
  HomeAddress = "homeAddress",
  FirstName = "firstName",
  LastName = "lastName",
  SourceStation2Id = "sourceStation2Id",
  Unit = "unitId",
}

// Tnufa
export enum TnufaChooseStationStepFormFieldsEnum {
  SourceStation2Id = "sourceStation2Id",
  Unit = "unit",
}

// NVIDIA SHUTTLE
export enum NvidiaShuttleChooseStationStepFormFieldsEnum {
  EmployeeNumber = "employeeNumber",
  FirstName = "firstName",
  LastName = "lastName",
  PhoneMobile = "phoneMobile",
  HomeAddress = "homeAddress",
  SourceStation2Id = "sourceStation2Id",
  DestinationId = "destinationId",
  AcceptTerms = "acceptTerms",
  AcceptPrivacyPolicy = "acceptPrivacyPolicy",
}

// WIX
export enum WixChooseStationStepFormFieldsEnum {
  EmployeeNumber = "employeeNumber",
  FirstName = "firstName",
  LastName = "lastName",
  Email = "email",
  PhoneMobile = "phoneMobile",
  SourceStation2Id = "sourceStation2Id",
  DestinationId = "destinationId",
  CampusStationId = "campusStationId",
  AcceptTerms = "acceptTerms",
  AcceptPrivacyPolicy = "acceptPrivacyPolicy",
}

// WEST NEGEV
export enum WestNegevChooseStationStepFormFieldsEnum {
  SiteId = "siteId",
  UnitId = "unitId",
  Age = "age",
  FirstName = "firstName",
  LastName = "lastName",
  PhoneMobile = "phoneMobile",
  PreferredStationId = "preferredStationId",
  HomeAddress = "homeAddress",
  SourceStation2Id = "sourceStation2Id",
  DestinationId = "destinationId",
  AcceptTerms = "acceptTerms",
  AcceptPrivacyPolicy = "acceptPrivacyPolicy",
}
